import React, {useEffect, useRef} from 'react';
import {FloatingOverlay, FloatingPortal} from '@floating-ui/react';

import theme from 'theme';

import type {CSSProperties, ReactNode} from 'react';
import type {ModalProps} from '../types';

type OverlayProps = Omit<ModalProps, 'children'> & {children: () => ReactNode};

export const ModalOverlay: React.FC<OverlayProps> = props => {
  const {children, targetRef, isOpen, isMounted, isPortal, zIndex = theme.zIndex.modal} = props;

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setTimeout(() => {
      if (!ref.current) {
        return;
      }

      ref.current.style.opacity = isOpen ? '1' : '0';
    });
  }, [isOpen]);

  if (!isOpen && !isMounted) {
    return null;
  }

  const style = ((): CSSProperties => {
    const hasTarget = !!targetRef;

    if (hasTarget) {
      return {
        zIndex,
        display: isOpen ? undefined : 'none',
      };
    }

    return {
      zIndex,

      display: isOpen ? 'flex' : 'none',
      top: 0,
      left: 0,
      opacity: 0,
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(59, 64, 71, 0.6)',
      transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)',
    };
  })();

  const Wrapper = isPortal ? FloatingPortal : React.Fragment;

  return (
    <Wrapper>
      <FloatingOverlay lockScroll={isOpen} style={style} ref={ref}>
        {children()}
      </FloatingOverlay>
    </Wrapper>
  );
};
